const catchAndRethrow = e => {
  throw e;
};
export default catchAndRethrow;